var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay music-content", class: _vm.position },
    [
      _c("audio", {
        ref: `music-preview`,
        on: { canplaythrough: (e) => (e.target.volume = "0.5") },
      }),
      _vm.musicSelected
        ? _c("div", { staticClass: "steep1" }, [
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      staticStyle: { "margin-bottom": "0px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "img",
                          class: {
                            play:
                              _vm.musicSelected.track &&
                              _vm.urlMusicPlaying ==
                                _vm.musicSelected.track
                                  .progressive_download_url,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleMusic(_vm.musicSelected)
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.musicSelected.track
                                ? _vm.musicSelected.track
                                    .cover_artwork_thumbnail_uri
                                : "",
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.musicSelected.track
                                ? _vm.musicSelected.track.title
                                : ""
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              _vm.musicSelected.track
                                ? _vm.musicSelected.track.display_artist
                                : ""
                            ) +
                              " · " +
                              _vm._s(
                                _vm.formatDuration(
                                  _vm.musicSelected.track
                                    ? _vm.musicSelected.track.duration_in_ms
                                    : 0
                                )
                              ) +
                              " · " +
                              _vm._s(
                                _vm.formatCount(
                                  _vm.musicSelected.tiktok_original
                                    ? _vm.musicSelected.tiktok_original
                                        .user_count
                                    : 0
                                )
                              ) +
                              " posts"
                          ),
                        ]),
                      ]),
                      _c("i", {
                        staticClass: "fa-regular fa-xmark",
                        on: { click: _vm.removeMusic },
                      }),
                    ]
                  ),
                  [
                    _c("CursorMusic", {
                      attrs: {
                        music: _vm.musicSelected,
                        defaultRangeDuration: _vm.models.duration.toString(),
                        defaultStart: _vm.models.start,
                        durationLock: _vm.durationLock,
                        videoDurationMs: _vm.videoDurationMs,
                      },
                      on: {
                        rangeDurationChange: _vm.rangeDurationChange,
                        startChange: _vm.startChange,
                      },
                    }),
                    _c("div", { staticClass: "balance" }, [
                      _c("h4", [_vm._v("Balance son")]),
                      _c("div", { staticClass: "inputRange" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.balance,
                              expression: "balance",
                            },
                          ],
                          attrs: {
                            type: "range",
                            min: "-1",
                            max: "1",
                            step: "0.01",
                          },
                          domProps: { value: _vm.balance },
                          on: {
                            __r: function ($event) {
                              _vm.balance = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "labels" }, [
                        _c("span", [
                          _vm._v(
                            "Son de la Vidéo (" + _vm._s(_vm.videoPct) + "%)"
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            "Son de la Musique (" + _vm._s(_vm.musicPct) + "%)"
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                ],
                2
              ),
            ]),
          ])
        : _c("div", { staticClass: "steep2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textSearch,
                      expression: "textSearch",
                    },
                  ],
                  attrs: { placeholder: "Rechercher une musique" },
                  domProps: { value: _vm.textSearch },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.runSearch.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textSearch = $event.target.value
                    },
                  },
                }),
              ]),
              !_vm.textSearch
                ? _c(
                    "div",
                    { staticClass: "navigation" },
                    _vm._l(Object.entries(_vm.feeds), function ([key, feed]) {
                      return _c(
                        "div",
                        {
                          key: key,
                          staticClass: "item-nav",
                          class: { active: _vm.selectedFeed === key },
                          on: {
                            click: function ($event) {
                              return _vm.selectFeed(key)
                            },
                          },
                        },
                        [_vm._v(_vm._s(feed.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "list-item hide-scrollbar",
                  on: { scroll: _vm.onScroll },
                },
                [
                  _vm.stateLoader && !_vm.loadingMore
                    ? _c("span", { staticClass: "loader" })
                    : !_vm.stateLoader && _vm.listMusics.length === 0
                    ? _c("p", { staticClass: "no-result" }, [
                        _vm._v("Aucune musique trouvée"),
                      ])
                    : _vm._l(_vm.listMusics, function (music, index) {
                        return _c(
                          "div",
                          {
                            key: `tiktok-music${index}`,
                            staticClass: "item",
                            on: {
                              click: function ($event) {
                                return _vm.selectMusic(music)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "img",
                                class: {
                                  play: _vm.urlMusicPlaying == music.audio_url,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleMusicRaw(music)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: { src: music.cover_url, alt: "" },
                                }),
                              ]
                            ),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "name" }, [
                                _vm._v(_vm._s(music.title)),
                              ]),
                              _c("p", { staticClass: "author" }, [
                                _vm._v(
                                  _vm._s(music.author) +
                                    " · " +
                                    _vm._s(_vm.formatDuration(music.duration)) +
                                    " · " +
                                    _vm._s(_vm.formatCount(music.user_count)) +
                                    " posts"
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                  _vm.loadingMore
                    ? _c("div", { staticClass: "loading-more" }, [
                        _c("i", { staticClass: "fa-solid fa-spinner fa-spin" }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
      _c("div", { staticClass: "btn-secondary", on: { click: _vm.close } }, [
        _vm._v("Fermer"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }